const api = {
  getToken: async () => {
    const response = await fetch('auth', {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
      },
    });
    return response.headers.get('Accesstoken') || '';
  },
  sendLogs: async (token: string, data: any) => {
    return await fetch('logs', {
      keepalive: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accesstoken': token,
      },
      body: data,
    });
  },
  getConfiguration: async () => {
    const response = await fetch('configuration.json', {
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
      },
    });
    return response.json();
  }
}

export default api;